import React from "react";
import { useSelector } from "react-redux";

const CompanyCard = () => {
  const { session } = useSelector((state) => state?.authProvider);

  const user = session?.user;

  const fullName =
    user?.firstName && user?.lastName
      ? `${user.firstName} ${user.lastName}`
      : "Unknown User";

  const userEmail = user?.email || "No email available";

  const userImage = user?.image?.url;

  return (
    <div className="bg-white p-4 rounded-lg shadow-md max-w-md mx-auto">
      {/* Header: User Image + Name */}
      <div className="items-center flex gap-3">
        {userImage ? (
          <img
            src={userImage}
            alt={fullName}
            className="w-16 h-16 rounded-full object-cover"
          />
        ) : (
          <div className="w-12 h-12 rounded-full bg-gray-200 flex items-center justify-center text-lg font-semibold text-gray-600 flex-shrink-0">
            {fullName.charAt(0)}
          </div>
        )}

        <div>
          <div className="font-semibold text-base text-gray-800">
            {fullName}
          </div>
          <div className="text-sm text-gray-500">{userEmail}</div>
        </div>
      </div>

      {/* Body */}
      <div className="mt-3 text-gray-600 text-sm font-sans">
        <p>{user?.firstName}, welcome back 👋</p>
        <p className="text-gray-500 mt-1">
          Discover companies and jobs tailored for you.
        </p>
      </div>
    </div>
  );
};

export default CompanyCard;
